export default __webpack_public_path__ + "static/media/Phone.d7a6dab6.png";